import figures from "./figures";
import register from "./ruleRegister.json";
import { leafPaths, ruleForPath } from "./ruleLifecycle";

/** Labels describe the shipped rules, never the visitor's wall-clock year. */
export const releasedRules = register.release;

export const resolveRuleTemplates = (text) => text
  .replace(/\{YEAR\}/g, String(releasedRules.referenceYear))
  .replace(/\{TAX_YEAR\}/g, releasedRules.taxYear);

/** Every scalar fact inherits explicit provenance from its registered rule group. */
export const getFigureProvenance = () => leafPaths(figures)
  .filter((field) => !field.startsWith("verified."))
  .map((field) => ({ field, rules: ruleForPath(register, field) }));
